import React from "react";
import { Link } from "react-router-dom";

// Make sure Bootstrap and Bootstrap Icons are imported globally for styles and icons
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap-icons/font/bootstrap-icons.css';

export default function Staffing() {
    return (
        <>
            {/* Top Banner Section */}
            <section className="py-5 bg-white-gradient text-center position-relative">
                <div className="container py-4">
                    <h1 className="display-5 fw-bold mb-2 staffing-gradient-text">
                        Power Up Your Team with Expert Staffing Solutions
                    </h1>
                    <p
                        className="lead text-secondary mb-4"
                        style={{ maxWidth: 650, margin: "0 auto" }}
                    >
                        We connect your business to world-class talent, fueling rapid
                        growth and innovation in a changing world.
                    </p>
                    <a
                        href="#whyus"
                        className="btn btn-lg btn-primary shadow px-5 py-2 fw-bold mt-3"
                    >
                        Why Choose Us?
                    </a>
                </div>
                {/* Decorative circle(s) for modern flair */}
                {/* <div
          className="position-absolute top-0 start-0 translate-middle opacity-25"
          style={{
            width: 180,
            height: 180,
            background: "linear-gradient(135deg, #6B46C1, #D53F8C)",
            borderRadius: "50%",
          }}
        ></div>
        <div
          className="position-absolute bottom-0 end-0 translate-middle opacity-10"
          style={{ width: 120, height: 120, background: "#D53F8C", borderRadius: "50%" }}
        ></div> */}
            </section>

            {/* Service Highlights */}
            <section id="whyus" className="py-5 bg-light">
                <div className="container">
                    <h2 className="text-center fw-bold mb-5 staffing-gradient-text">
                        Why Our Staffing Services?
                    </h2>
                    <div className="row g-4 justify-content-center">
                        <div className="col-md-4">
                            <div className="card border-0 shadow h-100 p-4 text-center bg-white">
                                <span
                                    className="rounded-circle bg-primary bg-opacity-10 d-inline-flex align-items-center justify-content-center mb-3 icon-70"
                                >
                                    <i className="bi bi-person-badge fs-2 text-primary"></i>
                                </span>
                                <h5 className="card-title staffing-gradient-text fw-bold">
                                    Tailored Talent Pools
                                </h5>
                                <p className="card-text small text-secondary">
                                    We rigorously curate our candidate network across IT, engineering,
                                    analytics, and business ops for an ideal fit, every time.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card border-0 shadow h-100 p-4 text-center bg-white">
                                <span
                                    className="rounded-circle bg-success bg-opacity-10 d-inline-flex align-items-center justify-content-center mb-3 icon-70"
                                >
                                    <i className="bi bi-lightning-charge-fill fs-2 text-success"></i>
                                </span>
                                <h5 className="card-title staffing-gradient-text fw-bold">
                                    Lightning Fast Placement
                                </h5>
                                <p className="card-text small text-secondary">
                                    Responsive, technology-driven matching means roles are often filled
                                    within days – not weeks!
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card border-0 shadow h-100 p-4 text-center bg-white">
                                <span
                                    className="rounded-circle bg-warning bg-opacity-10 d-inline-flex align-items-center justify-content-center mb-3 icon-70"
                                >
                                    <i className="bi bi-hand-thumbs-up-fill fs-2 text-warning"></i>
                                </span>
                                <h5 className="card-title staffing-gradient-text fw-bold">
                                    Quality Guaranteed
                                </h5>
                                <p className="card-text small text-secondary">
                                    Every candidate is vetted for skills, attitude, and cultural fit. Your satisfaction is our top priority.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Staffing Detailed Data Section */}
            <section className="py-5 bg-white">
                <div className="container">
                    {/* <h3 className="fw-bold text-primary text-center mb-4">Staffing</h3> */}

                    <p className="mb-4 fs-5">
                        IT staffing involves recruiting and placing information technology professionals in various roles within organizations. Here are some key points to consider:
                    </p>

                    <h4 className="mb-3 fw-semibold staffing-gradient-text">
                        1. Types of IT Staffing
                    </h4>
                    <ul className="mb-4">
                        <li><b>Contract Staffing:</b> Hiring IT professionals for specific projects or time-limited roles. This offers flexibility and allows companies to scale their workforce as needed.</li>
                        <li><b>Permanent Staffing:</b> Recruiting full-time employees to fill ongoing positions within the organization.</li>
                        <li><b>Temp-to-Perm Staffing:</b> Initially hiring on a temporary basis with the option for the candidate to transition to a permanent role after a trial period.</li>
                    </ul>

                    <h4 className="mb-3 fw-semibold staffing-gradient-text">
                        2. Common Roles
                    </h4>
                    <ul className="mb-4">
                        <li><b>Software Developers:</b> Create and maintain software applications.</li>
                        <li><b>Network Engineers:</b> Design, implement, and manage network systems.</li>
                        <li><b>Systems Administrators:</b> Oversee IT infrastructure and ensure systems run smoothly.</li>
                        <li><b>Cybersecurity Analysts:</b> Protect organizations from cyber threats.</li>
                        <li><b>Data Scientists/Analysts:</b> Analyze data to drive business decisions.</li>
                    </ul>

                    <h4 className="mb-3 fw-semibold staffing-gradient-text">
                        3. Staffing Process
                    </h4>
                    <ul className="mb-4">
                        <li><b>Needs Assessment:</b> Identifying specific IT skills and roles needed within the organization.</li>
                        <li><b>Sourcing Candidates:</b> Using job boards, recruitment agencies, social media, and networking to find qualified candidates.</li>
                        <li><b>Screening and Interviewing:</b> Evaluating candidates through interviews, technical assessments, and reference checks.</li>
                        <li><b>Placement:</b> Matching candidates to suitable roles based on their skills and the organization’s needs.</li>
                        <li><b>Onboarding:</b> Helping new hires acclimate to the organization and their roles.</li>
                    </ul>

                    <h4 className="mb-3 fw-semibold staffing-gradient-text">
                        4. Challenges
                    </h4>
                    <ul className="mb-4">
                        <li><b>Skill Shortages:</b> High demand for IT talent often exceeds the available supply, especially for specialized roles.</li>
                        <li><b>Keeping Up with Technology:</b> Rapid technological advancements can make it difficult for both candidates and employers to stay current.</li>
                        <li><b>Retention:</b> High turnover rates in the tech industry require companies to focus on employee engagement and satisfaction.</li>
                    </ul>

                    <h4 className="mb-3 fw-semibold staffing-gradient-text">
                        5. Trends
                    </h4>
                    <ul className="mb-4">
                        <li><b>Remote Work:</b> The shift to remote work has expanded the talent pool, allowing companies to hire from a wider geographic area.</li>
                        <li><b>Focus on Diversity and Inclusion:</b> Many organizations are actively seeking to improve diversity within their IT teams.</li>
                        <li><b>Upskilling and Reskilling:</b> Companies are investing in training programs to develop their existing workforce's skills to keep up with changing technologies.</li>
                    </ul>

                    <h4 className="mb-3 fw-semibold staffing-gradient-text">
                        6. Benefits of IT Staffing
                    </h4>
                    <ul>
                        <li><b>Access to Expertise:</b> Companies can tap into specialized skills that may not be available in-house.</li>
                        <li><b>Flexibility:</b> Organizations can quickly adjust their workforce in response to changing project needs.</li>
                        <li><b>Time Savings:</b> Staffing firms can streamline the recruitment process, saving time for internal HR teams.</li>
                    </ul>
                </div>
            </section>

            {/* Industries & Specialties */}
            <section className="py-5 bg-white">
                <div className="container">
                    <h3 className="fw-bold text-primary text-center mb-4">Our Staffing Specialties</h3>
                    <div className="row g-3 text-center justify-content-center">
                        <div className="col-6 col-md-3">
                            <div className="p-3 border rounded shadow-hover staffing-specialty">
                                <i className="bi bi-code-slash fs-3 text-primary d-block mb-2"></i>
                                <span className="fw-semibold">Technology & IT</span>
                            </div>
                        </div>
                        <div className="col-6 col-md-3">
                            <div className="p-3 border rounded shadow-hover staffing-specialty">
                                <i className="bi bi-bar-chart-fill fs-3 text-success d-block mb-2"></i>
                                <span className="fw-semibold">Finance & Analytics</span>
                            </div>
                        </div>
                        <div className="col-6 col-md-3">
                            <div className="p-3 border rounded shadow-hover staffing-specialty">
                                <i className="bi bi-telephone-fill fs-3 text-info d-block mb-2"></i>
                                <span className="fw-semibold">Customer Support</span>
                            </div>
                        </div>
                        <div className="col-6 col-md-3">
                            <div className="p-3 border rounded shadow-hover staffing-specialty">
                                <i className="bi bi-person-check-fill fs-3 text-warning d-block mb-2"></i>
                                <span className="fw-semibold">Operations & Admin</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Call to Action */}
            {/* <section className="py-5 bg-primary bg-gradient text-white text-center">
        <div className="container">
          <h3 className="fw-bold mb-3">Ready to Build Your Dream Team?</h3>
          <p className="mb-4">
            Contact us for a free staffing strategy session and see why top companies trust our expertise!
          </p>
          <Link to="/contact" className="btn btn-lg btn-light px-5 fw-bold shadow">
            Get in Touch
          </Link>
        </div>
      </section> */}

            {/* Full-Width Colored Section with Centered Content and Large Button */}
            <section className="py-12 bg-gradient-to-r from-purple-700 to-pink-600 text-white text-center position-relative overflow-hidden">
                <div className="container max-w-3xl relative z-10">
                    <h2 className="display-4 fw-bold mb-4" style={{ color: "#15d6ddff" }}>
                        Ready to Build Your Dream Team?
                    </h2>
                    <p className="lead mb-5 opacity-85">
                        Let’s collaborate and create powerful staffing strategies designed to take your business forward. Connect with our experts and start your journey today.
                    </p>
                    {/* <a
                        href="/contact"
                        className="btn btn-lg btn-light text-pink-600 fw-bold rounded-pill shadow-lg px-5 py-3"
                    >
                        Get in Touch
                    </a> */}
                </div>

                {/* Decorative blurred circles */}
                {/* <div
                    aria-hidden="true"
                    className="position-absolute top-0 start-0 translate-middle rounded-circle bg-pink-400 opacity-25"
                    style={{ width: 200, height: 200, filter: 'blur(60px)' }}
                ></div>
                <div
                    aria-hidden="true"
                    className="position-absolute bottom-0 end-0 translate-middle rounded-circle bg-purple-700 opacity-20"
                    style={{ width: 250, height: 250, filter: 'blur(80px)' }}
                ></div> */}
            </section>

            {/* Split Text & Image Block */}
            {/* <section className="py-12 bg-light">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6" data-aos="fade-right">
                            <h2 className="display-5 fw-bold mb-3">
                                Ready to Build Your Dream Team?
                            </h2>
                            <p className="lead mb-4">
                                Contact us for a free staffing strategy session and see why top companies trust our expertise!
                            </p>
                            <Link to="/contact" className="btn btn-primary btn-lg rounded-pill">
                                Get Started
                            </Link>
                        </div>
                        <div className="col-md-6 text-center" data-aos="fade-left">
                            <img
                                src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=600&q=80"
                                alt="Teamwork illustration"
                                className="img-fluid rounded shadow"
                                style={{ maxWidth: 400 }}
                            />
                        </div>
                    </div>
                </div>
            </section> */}

            {/* Card Style with Shadow and Hover Effect */}
            {/* <section className="py-10 d-flex justify-content-center">
                <div className="card shadow-lg p-5 rounded-4" style={{ maxWidth: '600px' }}>
                    <h3 className="fw-bold mb-4 text-center text-primary">
                        Ready to Build Your Dream Team?
                    </h3>
                    <p className="lead text-center mb-4">
                        Contact us for a free staffing strategy session and see why top companies trust our expertise!
                    </p>
                    <div className="d-flex justify-content-center">
                        <Link to="/contact" className="btn btn-outline-primary btn-lg rounded-pill px-5">
                            Get in Touch
                        </Link>
                    </div>
                </div>
            </section> */}

            {/* Button with Gradient and Animation */}

            <div className="d-flex justify-content-center">
                <Link
                    to="/contact"
                    className="btn btn-lg rounded-pill fw-bold text-white px-5 py-3"
                    style={{
                        background: 'linear-gradient(90deg, #6B46C1, #D53F8C)',
                        boxShadow: '0 4px 15px rgba(213, 63, 140, 0.6)',
                        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.05)';
                        e.currentTarget.style.boxShadow = '0 8px 30px rgba(213, 63, 140, 0.9)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                        e.currentTarget.style.boxShadow = '0 4px 15px rgba(213, 63, 140, 0.6)';
                    }}
                >
                    Get in Touch
                </Link>
            </div>



            {/* Custom styles for gradients and hover effects */}
            <style>{`
        .staffing-gradient-text {
          background: linear-gradient(90deg,#6b46c1,#d53f8c 75%);
          color: transparent;
          -webkit-background-clip: text;
          background-clip: text;
        }
        .bg-white-gradient {
          background: linear-gradient(135deg, #faf8ff 60%, #ffe2fa 100%);
        }
        .shadow-hover:hover {
          box-shadow: 0 0 24px rgba(107, 70, 193, 0.08), 0 2px 8px rgba(0,0,0,0.07) !important;
          transform: translateY(-2px) scale(1.02);
          transition: box-shadow 0.3s, transform 0.3s;
        }
        .staffing-specialty {
          transition: background 0.3s, box-shadow 0.3s;
          cursor: pointer;
        }
        .staffing-specialty:hover {
          background: #619ca7ff;
          box-shadow: 0 4px 20px #d53f8c24;
        }
      `}</style>
        </>
    );
}
